import { render, staticRenderFns } from "./ExternalScripts.vue?vue&type=template&id=0bd66bf8"
import script from "./ExternalScripts.vue?vue&type=script&lang=js"
export * from "./ExternalScripts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports